import { useRef } from 'react';

const VideoPlayer = ({ video_url }) => {
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <div>
      <video
        ref={videoRef}
        src={video_url}
        width="360"
        height="360"
        controls={true}
        // style={{ borderRadius: '12px'}}
      />
      <br />
    </div>
  );
};

export default VideoPlayer;
